import { render, staticRenderFns } from "./DashboardTrafficChart.vue?vue&type=template&id=827063b2&"
import script from "./DashboardTrafficChart.vue?vue&type=script&lang=js&"
export * from "./DashboardTrafficChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports